<template>
  <div
    :class="[
      'a-sticky-box',
      {
        'a-sticky-box--deaccessioned': isDeaccessioned
      }
    ]"
    tabindex="-1"
    aria-hidden="true"
    @click="scrollToTop"
  >
    <div class="a-sticky-box__text">
      <span
        v-if="heading"
        ref="heading"
        class="a-sticky-box__heading"
        data-testid="heading"
      >
        {{ heading }}
      </span>
      <p v-if="subheading" ref="subheading" class="a-sticky-box__subheading">
        {{ subheading }}
      </p>
      <DeaccessionedTag v-if="isDeaccessioned" />
    </div>
    <!-- image thumbnail if available -->
    <div v-if="imageUuid" class="a-sticky-box__image">
      <ImageResponsive
        :id="imageUuid"
        ref="image"
        size="post_xsmall_variable_height"
        :alt="imageAlt"
      />
    </div>
  </div>
</template>

<script>
import { ImageResponsive } from "@thegetty-private/getty-ui";
import mobileMixin from "@/mixins/mobileMixin/index.js";
import DeaccessionedTag from "@/components/atoms/deaccessionedTag/index.vue";

export default {
  name: "StickyBox",
  components: {
    DeaccessionedTag,
    ImageResponsive
  },
  mixins: [mobileMixin],
  props: {
    /**
     * The primary text displayed (i.e. primary_name of object, exhibition...)
     */
    heading: {
      type: String,
      default: undefined
    },
    /**
     * The alt text for the image thumbnail
     */
    imageAlt: {
      type: String,
      default: undefined
    },
    /**
     * The uuid of the iiif image (if available)
     */
    imageUuid: {
      type: String,
      default: undefined
    },
    /**
     * The secondary text displayed below the heading (i.e. artist or dates)
     */
    subheading: {
      type: String,
      default: undefined
    },
    /**
     * Whether or not the current object has been deaccessioned
     */
    isDeaccessioned: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * If we're in mobile scroll to the top
     */
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "auto"
      });
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
